import React from 'react';
import { RouteComponentProps, StaticContext } from 'react-router';
import { SwitchTemplate } from '@catalogo/core-switch-template';
import RenderComponent from '@catalogo/core-render-component';
import { Component } from '@catalogo/core-render-component/src/types';
import Spinner from '@catalogo/theme-spinner';
import { StatusCode } from '@catalogo/core-status-code';
import { useQueryTurbo } from './hooks/turbo';

export interface CustomStaticContext extends StaticContext {
  status: number;
}

export interface Props extends RouteComponentProps {
  staticContext: CustomStaticContext;
  Component: React.FC<Component>;
}

const isServer = typeof window === 'undefined';

const Redirect: React.FC<Props> = props => {
  const { location, Component } = props;
  const { pathname, search } = location;
  const { redirectTo, loading, error } = useQueryTurbo(pathname, search);
  const isSearchRoute = pathname?.includes('/busca');

  if (loading) {
    return isSearchRoute || isServer ? null : <Spinner />;
  }

  if (error || (!Component && !redirectTo)) {
    return (
      <>
        <StatusCode status={404} />
        <SwitchTemplate {...props} component="not-found" />
      </>
    );
  }

  if (redirectTo) {
    return <StatusCode status={301} url={redirectTo} />;
  }

  return <RenderComponent {...props} Component={Component} />;
};

export default Redirect;
